import { render, staticRenderFns } from "./ReviewSteps.vue?vue&type=template&id=50fba33a&scoped=true"
var script = {}
import style0 from "./ReviewSteps.vue?vue&type=style&index=0&id=50fba33a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fba33a",
  null
  
)

export default component.exports